const actionTypeIdentifier = 'EFE847B7-8A49-4696-8A84-F9B4492AB938'; //this is a newid

export const getInvoiceLineItems = `GET-INVOICE-LINE-ITEMS${actionTypeIdentifier}`;
export const setInvoiceLineItemsError = `SET-INVOICE-LINE-ITEMS-ERROR-${actionTypeIdentifier}`;
export const setInvoiceLineItemsColSearchStr = `SET-INVOICE-LINE-ITEMS-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const setInvoiceLineItemsPageSize = `SET-INVOICE-LINE-ITEMS-PAGESIZE-${actionTypeIdentifier}`;
export const sortInvoiceLineItems = `SORT-INVOICE-LINE-ITEMS-${actionTypeIdentifier}`;
export const resetInvoiceLineItems = `RESET-INVOICE-LINE-ITEMS-${actionTypeIdentifier}`;